import ErrorReporter from "@/components/ErrorReporter"
import VisualEditsMessenger from "./visual-edits/VisualEditsMessenger"
import Header from "@/components/sections/header"
import HeroSection from "@/components/sections/hero"
import Overview from "@/components/sections/overview"
import CostingSection from "@/components/sections/costing"
import FloorPlans from "@/components/sections/floor-plans"
import Gallery from "@/components/sections/gallery"
import Amenities from "@/components/sections/amenities"
import LocationSection from "@/components/sections/location"
import VirtualTour from "@/components/sections/virtual-tour"
import DeveloperInfo from "@/components/sections/developer-info"
import Footer from "@/components/sections/footer"
import PopupForm from "@/components/sections/popup-form"

function App() {
  return (
    <>
      <ErrorReporter />
      <div className="min-h-screen bg-[#f8f9fa] relative">
        <PopupForm />

        <Header />
        <main className="pt-[66px]">
          <HeroSection />
          <div className="container mx-auto px-4 lg:max-w-[1200px]">
            <Overview />
            <CostingSection />
            <FloorPlans />
            <Gallery />
            <Amenities />
            <LocationSection />
            <VirtualTour />
            <DeveloperInfo />
          </div>
        </main>
        <Footer />
      </div>
      <VisualEditsMessenger />
    </>
  )
}

export default App
